/**
 * Reusable Text Input component
 *
 * TODOs(Carter):
 *   - Support for error message + onLeave validation function
 *   - Add left/right element functionality for logos
 *   - Extend to other specific inputs
 */
import React from 'react';
import { BaseInputBar, StyledInput, ErrorText } from './TextArea.styled';
function TextArea(_a) {
    var _b = _a.width, width = _b === void 0 ? '100%' : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.invalid, invalid = _d === void 0 ? false : _d, _e = _a.placeholder, placeholder = _e === void 0 ? '' : _e, _f = _a.value, value = _f === void 0 ? '' : _f, _g = _a.height, height = _g === void 0 ? '60px' : _g, _h = _a.maxLength, maxLength = _h === void 0 ? 1000 : _h, _j = _a.errorText, errorText = _j === void 0 ? '' : _j, _k = _a.onChange, onChange = _k === void 0 ? function (e) {
        e.preventDefault();
    } : _k;
    return (React.createElement(React.Fragment, null,
        React.createElement(BaseInputBar, { height: height, width: width, invalid: invalid, disabled: disabled },
            React.createElement(StyledInput, { placeholder: placeholder, maxLength: maxLength, value: value, disabled: disabled, onChange: disabled
                    ? function (e) {
                        e.preventDefault();
                    }
                    : function (e) {
                        if (onChange) {
                            onChange(e);
                        }
                    } })),
        errorText !== '' && invalid ? React.createElement(ErrorText, null, errorText) : null));
}
export default TextArea;
